import $ from 'jquery';
import { merge } from 'lodash';
import noUiSlider from 'nouislider';
import 'style-loader!nouislider/distribute/nouislider.css';
import 'style-loader!./slider.css';

const MIN_PIXELS_PER_TICK = 4;

export function createSlider (target, sliderConfig, { isUnset = false, simplePips = false, formatFunction } = {}) {
  if (simplePips && sliderConfig.range) {
    const tickCount = (sliderConfig.range.max - sliderConfig.range.min) / sliderConfig.step + 1;
    const sliderWidth = parseInt(getComputedStyle(target.parentElement).width) || 264;
    if (tickCount * MIN_PIXELS_PER_TICK <= sliderWidth) {
      const values = Array.from({ length: tickCount }, (v, k) => k);
      sliderConfig.pips = {
        mode: 'values',
        values: values,
        stepped: true,
        density: 100 / tickCount
      };
    } else {
      // always generate pips at the start and end points to display start/end labels, even if tick count is too large.
      sliderConfig.pips = {
        mode: 'positions', // labels only at the given percentage-based positions
        values: [0, 100], // only at the start and end points
        density: 100 // density 1 pip every 100% -> no pips between start and end
      };
    }
    if (formatFunction) {
      sliderConfig.pips.format = { to: formatFunction };
    }
  }

  const slider = noUiSlider.create(target, sliderConfig);

  if (isUnset) {
    target.classList.add('unset');
    const removeUnset = () => {
      target.classList.remove('unset');
      // unfortunately slider.off('.unset') does not work because of a bug in noUiSlider.
      slider.off('set.unset');
      slider.off('start.unset');
    };
    slider.on('start.unset', removeUnset);
    slider.on('set.unset', removeUnset);
  }

  return slider;
}

export function createSliderTooltips (slider, formatFunction, separator, qTipOptions = {}) {
  const initialValues = Array.isArray(slider.options.start) ? slider.options.start : [slider.options.start];
  const qTips = initialValues.map((tickValue, handle) => {
    const handleEl = slider.target.querySelector(`.noUi-handle[data-handle="${handle}"]`);
    return createQtip(handleEl, values => formatFunction(values[handle]), qTipOptions);
  });

  const connectElement = slider.target.getElementsByClassName('noUi-connect')[0];
  let connectQTip;
  if (connectElement) {
    const connectFormatFunction = tickValues => tickValues.map(tickValue => formatFunction(tickValue)).join(` ${separator} `) || ' ';
    connectQTip = createQtip(connectElement, connectFormatFunction);
  }
  const started = Array(initialValues.length).fill(false);
  let activeQTip;

  slider.on('start', (values, handle) => {
    started[handle] = true;
    setTimeout(() => {
      if (activeQTip || !started.some(qTipStarted => qTipStarted)) {
        return;
      }

      if (connectElement && started.every(qTipStarted => qTipStarted)) {
        // qTip calculates width with jQuery, but jQeury does not take transform: scale into account.
        // To correct tooltip position, we set position.adjust.x parameter to x delta here.
        const adjustX = (connectElement.getBoundingClientRect().width - $(connectElement).outerWidth()) / 2;
        connectQTip.set('position.adjust.x', adjustX);
        activeQTip = connectQTip;
      } else {
        activeQTip = qTips[handle];
      }

      activeQTip.updateValue(values);
      activeQTip.show();
    });
  });

  slider.on('update', (values) => {
    if (activeQTip) {
      activeQTip.updateValue(values);
    }
  });

  slider.on('end', (values, handle) => {
    started[handle] = false;
    if (activeQTip) {
      activeQTip.hide();
      activeQTip = null;
    }
  });
}

function createQtip (target, formatFunction, qTipOptions) {
  if (!target) {
    return undefined;
  }

  const qTip = $(target).qtip(merge({
    show: false,
    hide: false,
    content: ' ',
    style: { classes: 'qtip-light' },
    position: {
      my: 'bottom left',
      at: 'top center',
      effect: false
    }
  }, qTipOptions)).qtip('api');
  qTip.updateValue = values => {
    qTip.set('content.text', formatFunction.call(this, values.map(Math.round)) || ' ');
  };
  return qTip;
}
